import { FC } from "react";
import "./style.scss";
import BtnDefault from "../../BtnDefault/BtnDefault";
import {
  onlineApplicationAllFieldsList,
  onlineApplicationsActionsConst,
  onlineApplicationsStatusTabsConst,
} from "@/src/constants/applicationOnlineConsts";
import VerticalLine from "../../VerticalLine/VerticalLine";
import { applicationPageSvgConst } from "@/src/svg/applicationsPage/applicationsPageSvgExport";
import { useDispatch, useSelector } from "react-redux";
import { toggleColumnVisibility, showAllColumns, hideAllColumns } from "@/src/store/slices/ApplicationPage/applicationsTableSlice";
import { RootState } from "@/src/store";
import { setFilterStatus } from "@/src/store/slices/ApplicationPage/applicationsFiltersSlice";
import { applicationPageRequests } from "@/src/api/applicationPageRequests";
// import { userChangeInfoRequest } from "@/src/api/userInfoRequests";
import { setActualUserConfig } from "@/src/store/slices/UserOptions/userOptionsSlice";

interface IAPHeaderProps {
  isShowSettingsModal: boolean;
  setIsShowSettingsModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsDocumentPreparationPopUpOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loadActualForm: () => void;
}

const APHeader: FC<IAPHeaderProps> = ({
  loadActualForm,
  isShowSettingsModal,
  setIsShowSettingsModal,
  setIsDocumentPreparationPopUpOpen,
}) => {
  // const APHeader: FC = () => {
  const dispatch = useDispatch();
  const actualSelectedRows = useSelector((state: RootState) => state.applicationsTable.selectedRows);
  const isMoveDisabled = actualSelectedRows.length !== 1;
  const { visibleColumns } = useSelector((state: RootState) => state.applicationsTable);
  const aopFixed = useSelector((state: RootState) => state.userOptions.AOPConfig.AOPFixed);
  const activeStatus = useSelector((state: RootState) => state.applicationsFilters.filterStatus);

  const handlers = {
    preview: () => console.log("Preview clicked"),
    comments: () => console.log("comments clicked"),
    download: () => console.log("download clicked"),
    unread: () => console.log("unread clicked"),
    admissionForward: () => console.log("admissionForward clicked"),
    tasks: () => console.log("tasks clicked"),
    move: () => {
      if (isMoveDisabled) return;
      setIsDocumentPreparationPopUpOpen(true);
    },
    delete: async () => {
      if (window.confirm("Are you sure you want to delete this item?")) {
        await applicationPageRequests.delete(actualSelectedRows);
        loadActualForm();
      }
    },
  };

  // const userID = localStorage.getItem("userID") ? localStorage.getItem("userID") : "";

  // useEffect(() => {
  //   const updateUserConfig = async () => {
  //     try {
  //       console.log("AOPConf updated:", userOptions);

  //       localStorage.setItem("userOptions", JSON.stringify(userOptions));

  //       const userConfigUpdate = await userChangeInfoRequest.userConfigUpdate(userID, userOptions);

  //       console.log("userAOPConfigUpdate", userConfigUpdate);
  //     } catch (error) {
  //       console.error("Error updating user config:", error);
  //     }
  //   };

  //   // вызов при изменении конфигурации
  //   if (userOptions) updateUserConfig();
  // }, [userOptions]);

  const handleSettingsModal = () => {
    setIsShowSettingsModal(!isShowSettingsModal);
    if (isShowSettingsModal) {
      dispatch(
        setActualUserConfig({
          AOPConfig: {
            AOPTable: visibleColumns,
            AOPFixed: aopFixed ?? null,
          },
        }),
      );
    }
  };

  return (
    <div className="applications-page-header">
      <div className="applications-page-header-body">
        <div className="status-tabs">
          {onlineApplicationsStatusTabsConst.map(({ id, label }) => (
            <button
              key={id}
              className={`status-tabs-item ${id === activeStatus ? "active" : ""}`}
              onClick={() => dispatch(setFilterStatus(id))}
            >
              {label}
            </button>
          ))}
        </div>
        <div className="header-actions">
          {onlineApplicationsActionsConst.map((action) => (
            <BtnDefault
              onlyIcon={true}
              key={action.name}
              disabled={action.name === "move" && isMoveDisabled}
              onClick={() => handlers[action.name as keyof typeof handlers]?.()}
            >
              <action.icon />
            </BtnDefault>
          ))}
          <VerticalLine />
          <BtnDefault onlyIcon={true} onClick={handleSettingsModal}>
            <applicationPageSvgConst.SettingsSvg />
          </BtnDefault>
        </div>
      </div>
      <div className={`applications-page-header-settings ${isShowSettingsModal ? "active" : ""}`}>
        <div className="applications-page-header-settings-ul">
          {onlineApplicationAllFieldsList.map((col) => (
            <div className="applications-page-header-settings-li" key={col.id}>
              <label>
                <input
                  type="checkbox"
                  checked={visibleColumns.some((c) => c.id === col.id)}
                  onChange={() => dispatch(toggleColumnVisibility(col.id))}
                />
                {/* <span className="checkmark"></span> */}
                <div className="applications-page-header-settings-li-tab">
                  <applicationPageSvgConst.SettingsTabPlusSvg />
                  <p>{col.title}</p>
                  <applicationPageSvgConst.SettingsTabDeleteSvg />
                </div>
              </label>
            </div>
          ))}
        </div>
        <div className="applications-page-header-settings-buttons">
          <div className="applications-page-header-settings-buttons-both">
            <BtnDefault onClick={() => dispatch(showAllColumns())}>
              <p>Choose all</p>
              <applicationPageSvgConst.ChooseAllSvg />
            </BtnDefault>
            <BtnDefault onClick={() => dispatch(hideAllColumns())}>
              <p>Clear all</p>
              <applicationPageSvgConst.ClearAllSvg />
            </BtnDefault>
          </div>
          <VerticalLine />
          <div className="applications-page-header-settings-buttons-save">
            <BtnDefault reverse={true} onClick={handleSettingsModal}>
              <p>Save</p>
              <applicationPageSvgConst.SaveSvg />
            </BtnDefault>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APHeader;
